/** @format */

import React, { useEffect, useRef, useState } from "react";
import { Input } from "antd";
import { PlusOutlined, SearchOutlined } from "@ant-design/icons";
import print from "../../../../../../icons/print.png";
import pdf from "../../../../../../icons/pdf.png";
import excel from "../../../../../../icons/excel.png";
import { seasonMonths } from "../../../../../../components/functions/Month";
import axios from "axios";
import { header } from "../../../../../../components/api/Header";
import { add_func } from "../../../../../../components/functions/Mathematik";
import { user_data } from "../../../../../../components/functions/usr";
import { NavLink } from "react-router-dom";
import { useReactToPrint } from "react-to-print";
import { ExcelPrint, Pdf } from "../../../../../../components/functions/Print";
import LoadingCard from "../../../../../../components/loading/loadingCard";
import { getEnv } from "../../../../../../lib/env";

function Table() {
  const conponentPDF = useRef();
  const [data, setData] = useState([]);
  const [season, setSeason] = useState("veg");
  const [loading, setLoading] = useState(false);

  const [year, setYear] = useState(new Date().toISOString().slice(0, 4));
  const [lyear, setLyear] = useState(year);

  let sum1 = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
  let sum2 = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];

  const setSearch = (text) => {
    console.log(text);
  };

  useEffect(() => {
    setYear(lyear);
  }, [lyear]);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const res = await axios.get(
          getEnv('REACT_APP_BASE_URL') +
            "/v1/region/limitptn/dekada?year=" +
            year +
            "&season=" +
            season,
          header()
        );
        setData(res.data.data);
      } catch (e) {
        console.log("Xato", e);
        alert("Server bilan aloqa yo'q");
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [year, season]);

  const generatePDF = useReactToPrint({
    content: () => conponentPDF.current,
    documentTitle: "Userdata",
  });

  return (
    <>
      <div className='table-content-top'>
        <div className='table-top-left'>
          <Input
            prefix={<SearchOutlined className='site-form-item-icon' />}
            placeholder='Search'
            onChange={(e) => setSearch(e.target.value)}
          />
        </div>

        <ul className='table-top-right'>
          {user_data() ? (
            user_data().region_id == 16 ? (
              <li>
                <NavLink
                  to='/limit/ptn/dekadalik/add'
                  className='btn btn-sm btn-outline-primary d-flex align-items-center'>
                  Ma'lumot kiritish &nbsp;&nbsp;&nbsp;
                  <PlusOutlined />
                </NavLink>
              </li>
            ) : null
          ) : null}

          <li className='d-flex align-items-center'>
            <input
              type='number'
              className='form-control form-control-sm'
              min={2015}
              max={parseInt(new Date().toISOString().slice(0, 4)) + 2}
              value={lyear}
              onChange={(e) => setLyear(e.target.value)}
            />
          </li>

          <li>
            <select
              className='form-select form-select-sm'
              onChange={(e) => setSeason(e.target.value)}
              value={season}>
              <option value='veg'>Sug'orish mavsumi</option>
              <option value='noveg'>Nosug'orish mavsumi</option>
            </select>
          </li>

          <li>
            <button className='btn p-0' onClick={() => generatePDF()}>
              <img src={print} alt='404' />
            </button>
          </li>

          <li>
            <button onClick={() => Pdf("tblData")} className='btn p-0'>
              <img src={pdf} alt='404' />
            </button>
          </li>

          <li>
            <button
              className='btn p-0'
              onClick={() => ExcelPrint("PTN", "sheet 1", "tblData")}>
              <img src={excel} alt='404' />
            </button>
          </li>
        </ul>
      </div>

      {loading ? (
        <LoadingCard loading={loading} heightSize='80vh' />
      ) : (
        <div className='table-responsive tableFixHead'>
          <div ref={conponentPDF} style={{ width: "100%" }}>
            <table id='tblData' className='table table-bordered table-style'>
              <thead>
                <tr>
                  <th colSpan={22}>
                    Qoraqalpog‘iston Respublikasi va viloyatlarga {year}-yil{" "}
                    {season == "noveg" ? "no" : null}sug‘orish mavsumida
                    ajratilgan suv olish limiti
                  </th>
                </tr>

                <tr>
                  <th rowSpan={2} scope='col'>
                    №
                  </th>

                  <th rowSpan={2} scope='col'>
                    Hududlar nomi
                  </th>

                  <th rowSpan={2} scope='col'>
                    Ko‘rsatkichlar
                  </th>

                  {seasonMonths(season).map((s, i) => {
                    return (
                      <th key={i} colSpan={3}>
                        {s}
                      </th>
                    );
                  })}
                </tr>

                <tr>
                  <th scope='col'>I</th>
                  <th scope='col'>II</th>
                  <th scope='col'>III</th>
                  <th scope='col'>I</th>
                  <th scope='col'>II</th>
                  <th scope='col'>III</th>
                  <th scope='col'>I</th>
                  <th scope='col'>II</th>
                  <th scope='col'>III</th>
                  <th scope='col'>I</th>
                  <th scope='col'>II</th>
                  <th scope='col'>III</th>
                  <th scope='col'>I</th>
                  <th scope='col'>II</th>
                  <th scope='col'>III</th>
                  <th scope='col'>I</th>
                  <th scope='col'>II</th>
                  <th scope='col'>III</th>
                </tr>
              </thead>

              {data.length > 0
                ? data.map((d, i) => {
                    if (i == 0) {
                      sum1 = [
                        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
                      ];
                      sum2 = [
                        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
                      ];
                    }
                    Array(18)
                      .fill()
                      .map((_, ind) => {
                        sum1[ind] = add_func(
                          sum1[ind],
                          d.sugorish["d" + (ind + 1)]
                        );
                        sum2[ind] = add_func(sum2[ind], d.ste["d" + (ind + 1)]);
                        return null;
                      });

                    return (
                      <tbody key={i}>
                        <tr>
                          <th rowSpan={3} className='vertical-middle'>
                            {i + 1}
                          </th>

                          <th rowSpan={3} className='vertical-middle'>
                            {d.name}
                          </th>

                          <th>
                            <b>jami</b>
                          </th>

                          {Array(18)
                            .fill()
                            .map((_, ind) => {
                              return (
                                <th key={ind}>
                                  {add_func(
                                    d.ste["d" + (ind + 1)],
                                    d.sugorish["d" + (ind + 1)]
                                  )}
                                </th>
                              );
                            })}
                        </tr>

                        <tr>
                          <th>sh.j. sug‘orishga</th>
                          {Array(18)
                            .fill()
                            .map((_, ind) => {
                              return (
                                <th key={ind}>{d.sugorish["d" + (ind + 1)]}</th>
                              );
                            })}
                        </tr>

                        <tr>
                          <th>
                            <i>STE va boshqalar</i>
                          </th>

                          {Array(18)
                            .fill()
                            .map((_, ind) => {
                              return (
                                <th key={ind}>{d.ste["d" + (ind + 1)]}</th>
                              );
                            })}
                        </tr>
                      </tbody>
                    );
                  })
                : null}

              <tbody>
                <tr>
                  <th rowSpan={4} colSpan={2} className='vertical-middle'>
                    Respublika bo‘yicha jami
                  </th>

                  <th>
                    <b>jami</b>
                  </th>

                  {sum1.map((s, i) => {
                    return <th key={i}>{add_func(s, sum2[i])}</th>;
                  })}
                </tr>

                <tr>
                  <th>sh.j. sug‘orishga</th>
                  {sum1.map((s, i) => {
                    return <th key={i}>{s}</th>;
                  })}
                </tr>

                <tr>
                  <th>
                    <i>STE va boshqalar</i>
                  </th>

                  {sum2.map((s, i) => {
                    return <th key={i}>{s}</th>;
                  })}
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      )}
    </>
  );
}

export default Table;
